import React from "react";
import Accordion from "react-bootstrap/Accordion";
import PaginationModified from "../../data/PaginationModified";
import {
  convertStraight,
  convertTimeRangeHHMMSS,
  formatTimezoneThenStraight,
} from "../common-data/Converts";
import {
  CheckCircleIcon,
  CrossCircleIcon,
  DownloadIcon,
} from "../../images/icons/icons";

const TMELogsMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  setClickValues,
  loading,
  handleDelete,
  userInfoData,
  pageLimit,
  setPageLimit,
}) => {
  const isAdmin = userInfoData?.account_type === "admin";

  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          const isFirstBCA = row?.bca_report;

          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="log-card-top">
                  <div
                    className="profile-name-number"
                    style={{
                      columnGap: "0",
                      height: "auto",
                    }}
                  >
                    <div className="name-number">
                      <h3 className="lead-name">{row?.user_name || "NA"}</h3>
                      <p className="number">{row?.user_mobile || "NA"}</p>
                      {row?.email ? (
                        <span className="value email semi-bold">
                          {row?.user_email || "NA"}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="all-followuo-info-container">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header style={{ padding: "0 10px 10px 10px" }}>
                        Show More
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="lead-multi-value-cols px20px pb20px">
                          <div className="label-value flex-col">
                            <span className="label">Date added</span>
                            <span className="value">
                              {row?.date_added
                                ? formatTimezoneThenStraight(row.date_added)
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">plan Status</span>
                            <span
                              className="value"
                              style={{
                                background:
                                  row?.current_plan_status === "active"
                                    ? "#379C00"
                                    : row?.current_plan_status === "pending"
                                    ? "#157EF9"
                                    : "#C80000",
                                color: "#fff",
                                padding: "3px",
                                borderRadius: "6px",
                              }}
                            >
                              {row?.current_plan_status?.replace(/_/g, " ") ||
                                "NA"}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">
                              Regular subscription expiring in
                            </span>
                            <span
                              className="value"
                              style={{
                                color: "#f13434",
                              }}
                            >
                              {row?.subscription_expiry_days || "-"}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">Trainer Info</span>
                            <span className="value">
                              {" "}
                              {row?.trainer_name || "NA"}
                              <br />
                              <small style={{ textTransform: "lowercase" }}>
                                {row?.trainer_mobile || ""}
                                <br />
                                {row?.trainer_email || ""}
                              </small>
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">Member Last Checkin</span>
                            <span
                              className="value link"
                              onClick={() =>
                                setClickValues((prevs) => ({
                                  ...prevs,
                                  userId: row?.user_id,
                                  isModOpen: true,
                                  cardName: "member_checkin_details",
                                  sendableStatsQPs: `&start_date=${
                                    row?.last_checkin || ""
                                  }&end_date=${row?.last_checkin || ""}`,
                                }))
                              }
                            >
                              {" "}
                              {convertStraight(row?.last_checkin) || "-"}
                              <br />
                              {convertTimeRangeHHMMSS(row?.checkin_time) || ""}
                              <br />
                              {row?.last_checkin_days_ago
                                ? `(${row.last_checkin_days_ago?.replace(
                                    /_/g,
                                    " "
                                  )})`
                                : ""}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">Member Last Workout</span>
                            <span
                              className="value link"
                              onClick={() =>
                                setClickValues((prevs) => ({
                                  ...prevs,
                                  userId: row?.user_id,
                                  isModOpen: true,
                                  cardName: "member_workout_details",
                                  sendableStatsQPs: `&date_from=${
                                    row?.last_checkin || ""
                                  }&date_to=${row?.last_checkin || ""}`,
                                  workoutDate: row?.last_workout_date,
                                }))
                              }
                            >
                              {convertStraight(row?.last_workout_date) || "-"}
                              <br />
                              {row?.last_workout_status?.replace(/_/g, " ") ||
                                ""}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">
                              interested for PT trial
                            </span>
                            <span className="value">
                              {row?.free_pt_consultation ? (
                                <CheckCircleIcon />
                              ) : (
                                <CrossCircleIcon />
                              )}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">PT Trial date</span>
                            <span className="value">
                              {row?.pt_schedule_date
                                ? convertStraight(row.pt_schedule_date)
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">Transformation</span>
                            <span
                              className={`value ${
                                row?.prog_pics?.length > 0 ? "link" : "icon"
                              }`}
                            >
                              {row?.prog_pics?.length > 0 ? (
                                <b
                                  onClick={() =>
                                    setClickValues((prevs) => ({
                                      ...prevs,
                                      isModOpen: true,
                                      rowData: row,
                                      cardName: "transformation_images",
                                    }))
                                  }
                                >
                                  View Images
                                </b>
                              ) : (
                                <CrossCircleIcon />
                              )}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">fitness profile</span>
                            <span
                              className="value icon"
                              onClick={() =>
                                setClickValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  cardName: "fitness_profile_logs",
                                  rowData: row,
                                }))
                              }
                            >
                              {row?.fitness_profile !== "pending" ? (
                                <CheckCircleIcon />
                              ) : (
                                <CrossCircleIcon />
                              )}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">
                              current trainer rating
                            </span>
                            <span
                              className="value link"
                              onClick={() =>
                                setClickValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  cardName: "trainer_rating_logs",
                                  rowData: row,
                                }))
                              }
                            >
                              {row?.current_trainer_avg_rating || "-"}{" "}
                              {row?.current_trainer_avg_rating && "★"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">consultation data</span>
                            <span
                              className="value link"
                              onClick={() =>
                                setClickValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  rowData: row,
                                  cardName: "consultation_data",
                                }))
                              }
                            >
                              view
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">First BCA Report</span>
                            <span className="value icon">
                              {row?.bca_report ? (
                                <a href={row?.bca_report}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-cloud-arrow-down"
                                    viewBox="0 0 16 16"
                                    style={{
                                      color: "#209216",
                                      minWidth: "35px",
                                      minHeight: "35px",
                                    }}
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                                    />
                                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                  </svg>
                                </a>
                              ) : (
                                <CrossCircleIcon />
                              )}
                            </span>
                          </div>
                        </div>

                        <div className="all-btns lead-btn-axceed">
                          <div className="lead-log-box">
                            <button
                              className="lead-log view-lead"
                              disabled={!isFirstBCA}
                              onClick={() =>
                                isFirstBCA &&
                                setClickValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  rowData: row,
                                  cardName: "bca_report",
                                }))
                              }
                              style={{
                                color: "blue",
                                fontWeight: "bold",
                                opacity: isFirstBCA ? 1 : 0.5,
                              }}
                            >
                              View
                            </button>

                            <span className="btn-label">BCA Report</span>
                          </div>

                          <div className="lead-log-box">
                            <button
                              className="lead-log view-lead"
                              disabled={false}
                              onClick={() =>
                                setClickValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  rowData: row,
                                  editInfo: {
                                    user_id: row?.trainer_id,
                                    name: row?.trainer_name,
                                    email: row?.trainer_email,
                                    mobile: row?.trainer_mobile,
                                    token: userInfoData?.token,
                                    gym_id: row?.gym_id,
                                    gym_name: row?.gym_name,
                                    account_type: "trainer",
                                  },
                                  cardName: "edit",
                                }))
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-pencil-fill"
                                viewBox="0 0 16 16"
                                style={{
                                  color: "#CD0909",
                                }}
                              >
                                <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                              </svg>
                            </button>

                            <span className="btn-label">Edit</span>
                          </div>

                          {isAdmin && (
                            <>
                              <div className="lead-log-box">
                                <button
                                  className="lead-log view-lead"
                                  disabled={loading}
                                  style={{
                                    cursor: loading ? "not-allowed" : "pointer",
                                  }}
                                  onClick={(e) => {
                                    const payload = {
                                      uid: row?.uid,
                                    };
                                    handleDelete(payload);
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-trash3-fill"
                                    viewBox="0 0 16 16"
                                    style={{
                                      color: "#CD0909",
                                    }}
                                  >
                                    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                                  </svg>
                                </button>

                                <span className="btn-label">Delete</span>
                              </div>

                              <div className="lead-log-box">
                                <button
                                  className="lead-log view-lead"
                                  disabled={loading}
                                  style={{
                                    cursor: "pointer",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={() =>
                                    setClickValues((prevs) => ({
                                      ...prevs,
                                      isModOpen: true,
                                      rowData: row,
                                      cardName: "member_map",
                                    }))
                                  }
                                >
                                  <DownloadIcon />
                                </button>

                                <span className="btn-label">Map</span>
                              </div>
                            </>
                          )}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default TMELogsMobile;
